/**
 * The phone drawer's "More pages" — every desktop sidebar page the bottom bar
 * and the drawer's quick picks do not reach (audit 2026-11-02, #33).
 *
 * Drawn from the desktop sidebar's own menu (useSidebarNavigation +
 * composeAreaNavigation), for all four areas at once: the phone has no
 * sidebar beside the page, so it lists every area's pages in one drawer
 * rather than only the area you are in.
 */
import { useMemo } from 'react';
import {
  composeAreaNavigation,
  useSidebarNavigation,
} from '../components/prioritization/useSidebarNavigation';
import { useAllAreaReports } from '../hooks/prioritization/useAreaReports';
import type { AppArea } from '../lib/appAreas';
import { phoneMorePages, phoneQuickPickHrefs, type MobileNavSection } from './navConfig';

/** Left to right, as the area switch draws them. */
const AREAS: AppArea[] = ['strategy', 'priorities', 'plans', 'action'];

export function usePhoneMorePages(): MobileNavSection[] {
  const { navigation, timePhasedEnabled, evidenceEnabled } = useSidebarNavigation();
  const reports = useAllAreaReports();

  return useMemo(
    () =>
      phoneMorePages(
        AREAS.map((area) => ({
          area,
          sections: composeAreaNavigation(navigation, area, { reports, timePhasedEnabled, evidenceEnabled }),
        })),
        phoneQuickPickHrefs(),
      ),
    [navigation, reports, timePhasedEnabled, evidenceEnabled],
  );
}
